import styled from "styled-components";

import CustomButton from "../../../helperComponents/CustomButton";
import WithBackground from "../../../core/boilerplate/WithBackground";
import LoggedInHeader from "../LoggedInHeader";
import InputCard from "../../../helperComponents/InputCard";
import logout from "../../../../controllers/logout";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import { useContext } from "react";
import Context from "../../../../Context";
import adminAccess from "../../../../data/adminAccess";
import { useTranslation } from "react-i18next";
import TitleBar from "../../../helperComponents/TitleBar";
import LoadingSection from "../../../helperComponents/LoadingSection";
import navBarOptions from "../../../../data/navBarOptions";
import goTo from "../../../../controllers/goTo";
import { BiLogOut, BiUser } from "react-icons/bi";
import { MdPassword } from "react-icons/md";
import { PiCarProfile } from "react-icons/pi";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  align-items: center;
  gap: 50px;
`;

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`;

export default function OptionsPageForMobile() {
  const { loggedInUser } = useContext(Context);
  const { t } = useTranslation();

  if (!loggedInUser)
    return (
      <LoggedInBoilerplate showBackgroundImage={true}>
        <TitleBar>Paramètres</TitleBar>
        <LoadingSection />
      </LoggedInBoilerplate>
    );

  return (
    <LoggedInBoilerplate
      titleLine1={"Page"}
      titleLine2={"D'Options"}
      showBackgroundImage={true}
    >
      {/* <TitleBar> Paramètres </TitleBar> */}
      <Container>
        <Inputs>
          {navBarOptions.map((item) => {
            return (
              <CustomButton
                key={item.link}
                icon={item.icon}
                onClick={goTo(item.link)}
              >
                {item.label}
              </CustomButton>
            );
          })}

          <CustomButton icon={<BiLogOut />} onClick={logout}>
            Déconnexion
          </CustomButton>

          <CustomButton
            icon={<BiUser />}
            href={`/employee/${loggedInUser._id}`}
          >
            Profil
          </CustomButton>

          <CustomButton icon={<MdPassword />} href={`/change-password`}>
            changer le mot de passe
          </CustomButton>
        </Inputs>
      </Container>
    </LoggedInBoilerplate>
  );
}
